export function initRequest({ route, path }: { route: string; path: string }) {
  process.env.__archonRequestMetadata = JSON.stringify({
    timestamp: Date.now(),
    route,
    path,
  });
}

export function getRequestMetadataHeaders() {
  if (!process.env.__archonRequestMetadata) return {};

  const metadata = JSON.parse(process.env.__archonRequestMetadata);

  return {
    'x-archon-timestamp': metadata.timestamp.toString(),
    'x-archon-current-duration': (Date.now() - metadata.timestamp).toString(),
    'x-archon-route': metadata.route,
    'x-archon-path': metadata.path,
  };
}
